import {
  getObject,
  getLeoUuid,
  LeoUUID,
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";

export interface EmailCycleNameDTO {
  cycleName: BoundedNameDTO;
  scheduleId: string;
}

export class EmailCycleName {
  readonly isEmailCycleNameEmailCycleName: boolean = true;

  readonly cycleName: BoundedName;
  readonly scheduleId: LeoUUID;


  constructor(
  cycleName: BoundedName, 
  scheduleId: LeoUUID
  ) {
    this.cycleName = cycleName;
    this.scheduleId = scheduleId;
  }

  static fromDTO(dto: EmailCycleNameDTO): EmailCycleName {
    const cycleName = BoundedName.fromDTO(getObject(dto, "cycleName", InvalidEmailCycleNameCycleNameError));
    const scheduleId = getLeoUuid(dto, "scheduleId", InvalidEmailCycleNameScheduleIdError);
    return new EmailCycleName(
      cycleName,
      scheduleId
    );
  }

  toDTO(): EmailCycleNameDTO {
    const dto: EmailCycleNameDTO = {
        cycleName: this.cycleName.toDTO(),
        scheduleId: this.scheduleId.toDTO()
    };
    return dto;
  }
  }

EmailCycleName.prototype.toString = function toString(): string {
  return `EmailCycleName(cycleName='${this.cycleName}',scheduleId='${this.scheduleId}')`;
};

export class InvalidEmailCycleNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleNameError";
  }
}
export class InvalidEmailCycleNameCycleNameError extends InvalidEmailCycleNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleNameCycleNameError";
  }
}

export class InvalidEmailCycleNameScheduleIdError extends InvalidEmailCycleNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleNameScheduleIdError";
  }
}
